import withIntl from "../../utils/withIntl";
import React, { useState } from "react";
import TextFieldForms from "../Forms/TextFieldForms";
import InputAdornment from "@material-ui/core/InputAdornment";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import ChangeAmountButtons from "./ChangeAmountButtons";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Checkbox, FormControlLabel } from "@material-ui/core";

const useStyles = makeStyles({
  textFieldContainer: {
    display: "flex",
    flexDirection: "column",
    margin: 10,
  },
  label: { width: "100%" },
  input: { width: "100%" },
});

function RoundCategoriesSetting(props) {
  const classes = useStyles();
  const [newCategoryKey, setNewCategoryKey] = React.useState("");
  const [noLimit, setNoLimit] = useState(props.setting == null);

  const setting = props.setting ?? {};
  return (
    <div className={classes.textFieldContainer}>
      <div className={classes.label}>
        <Typography style={{ fontWeight: 600 }}>Round {props.intl.formatMessage({ id: "categories" })}</Typography>
        <Typography variant="caption" style={{ color: "gray" }}>
          {props.helperTextLabel ?? ""}
        </Typography>
      </div>
      <div className={classes.input}>
        <FormControlLabel
          label={"No limit"}
          control={
            <Checkbox
              checked={noLimit}
              onChange={(e) => {
                setNoLimit(e.target.checked);
                if (e.target.checked) {
                  props.onChangeFields(null);
                } else {
                  props.onChangeFields(setting);
                }
              }}
            />
          }
        />
        {!noLimit && (
          <>
            <TextFieldForms
              value={newCategoryKey}
              onChange={(e) => {
                setNewCategoryKey(e.target.value);
              }}
              label={props.intl.formatMessage({ id: "categories" })}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <AddCircleIcon
                      onClick={() => {
                        let newCategory = { [newCategoryKey]: { max_rounds: 1 } };
                        props.updateCategories(newCategory);
                        setNewCategoryKey("");
                      }}
                      color={"primary"}
                    />
                  </InputAdornment>
                ),
              }}
            />
            {Object.keys(setting).map((key) => {
              if (key !== "max_rounds")
                return (
                  <>
                    <Typography>{key}</Typography>
                    <ChangeAmountButtons
                      value={setting[key].max_rounds}
                      setValue={(value) => {
                        let newCategory = { [key]: { max_rounds: parseInt(value) } };
                        props.updateCategories(newCategory);
                      }}
                      onDelete={() => {
                        let categorie = { [key]: setting[key] };
                        props.updateCategories(categorie, "removed");
                      }}
                    />
                  </>
                );
            })}
          </>
        )}
        <Divider style={{ marginTop: "8px", marginBottom: "8px" }} />
      </div>
    </div>
  );
}

export default withIntl(RoundCategoriesSetting);
